import { useState } from "react";
import { toast } from "sonner";
import { Palmtree, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const fmt = (iso) => new Date(`${iso}T00:00:00+07:00`).toLocaleDateString("id-ID", { weekday: "short", day: "numeric", month: "short", timeZone: "Asia/Jakarta" });

export function DaysOffEditor({ daysOff = [], onSaved }) {
  const [date, setDate] = useState("");
  const [saving, setSaving] = useState(false);
  const today = new Date().toLocaleDateString("sv-SE", { timeZone: "Asia/Jakarta" });

  const save = async (next) => {
    setSaving(true);
    try {
      const { data } = await api.patch("/talent/me", { days_off: next });
      onSaved(data);
      if (data.affected_orders?.length) toast.warning(`Ada order terjadwal di hari libur ini: ${data.affected_orders.join(", ")}. Order tetap berjalan, hubungi admin jika perlu dialihkan.`, { duration: 8000 });
      else toast.success("Hari libur diperbarui");
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  const add = (e) => {
    e.preventDefault();
    if (!date) return;
    if (daysOff.includes(date)) return toast.error("Tanggal sudah ada");
    save([...daysOff, date]); setDate("");
  };

  return (
    <div className="card-soft p-5" data-testid="days-off-editor">
      <p className="font-heading font-medium text-slate-800 inline-flex items-center gap-2"><Palmtree size={16} strokeWidth={1.5} className="text-primary" />Libur sementara</p>
      <p className="mt-1 text-sm text-slate-500 leading-relaxed">Tanggal yang ditandai libur otomatis hilang dari pilihan slot user.</p>
      <form onSubmit={add} className="mt-3 flex gap-2">
        <input type="date" min={today} value={date} onChange={(e) => setDate(e.target.value)} className="h-10 px-3 rounded-lg border border-border bg-card text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-primary/40" data-testid="days-off-date-input" />
        <button className="btn-outline h-10 px-4 text-sm" disabled={saving || !date} data-testid="days-off-add-button">Tandai libur</button>
      </form>
      <div className="mt-3 flex flex-wrap gap-2" data-testid="days-off-list">
        {daysOff.length === 0 && <span className="text-xs text-slate-400" data-testid="days-off-empty">Belum ada hari libur.</span>}
        {daysOff.map((d) => (
          <span key={d} className="inline-flex items-center gap-1 pl-3 pr-1 h-8 rounded-full bg-secondary text-secondary-foreground text-xs" data-testid={`days-off-item-${d}`}>
            {fmt(d)}
            <button type="button" onClick={() => save(daysOff.filter((x) => x !== d))} disabled={saving} className="p-1 rounded-full hover:bg-rose-100 hover:text-rose-700 transition-colors" data-testid={`days-off-remove-${d}`} aria-label="Hapus"><X size={12} strokeWidth={1.5} /></button>
          </span>
        ))}
      </div>
    </div>
  );
}
